import type { AdminCompleteExpertReview, AdminExpertReviewView } from '@repo/shared'
import { json, request } from './api'
import type { GetToken } from './lib/auth'

/** 전문가 검수 대기열 API (로드맵 매출 8위). api.ts 를 덜 고치려고 따로 둔다 */
export const expertReviewsApi = {
  list: (getToken: GetToken, view: 'open' | 'closed') =>
    request<{ items: AdminExpertReviewView[] }>(getToken, `/admin/expert-reviews?view=${view}`),
  get: (getToken: GetToken, id: string) =>
    request<{ review: AdminExpertReviewView }>(
      getToken,
      `/admin/expert-reviews/${encodeURIComponent(id)}`,
    ),
  start: (getToken: GetToken, id: string) =>
    request<{ review: AdminExpertReviewView }>(
      getToken,
      `/admin/expert-reviews/${encodeURIComponent(id)}/start`,
      { method: 'POST' },
    ),
  complete: (getToken: GetToken, id: string, body: AdminCompleteExpertReview) =>
    request<{ review: AdminExpertReviewView }>(
      getToken,
      `/admin/expert-reviews/${encodeURIComponent(id)}/complete`,
      json('POST', body),
    ),
  reject: (getToken: GetToken, id: string, reason: string) =>
    request<{ review: AdminExpertReviewView; creditReturned: boolean }>(
      getToken,
      `/admin/expert-reviews/${encodeURIComponent(id)}/reject`,
      json('POST', { reason }),
    ),
}
